
import Server from "src/server";
import Util from "src/util/util";

export default
{
  namespaced: true,
  state:
    {
      isLoading: false,
      workflow: null,
      workflows: []
    },

  mutations:
    {

    },

  actions:
    {
      reset(context)
      {
        context.state.workflows = [];
      },

      async setWorkflow(context, {workflow}) {
        try {
          context.state.isLoading = true;
          var result = await Server.post("getWorkflow", {workflow: workflow}).promise;
          context.state.isLoading = false;
          if(!result.data.success)
            throw(result.data.error);

          context.state.workflow = result.data.workflow;
          return {data: {success: true, workflow: context.state.workflow}};
        }
        catch(e) {
          console.log("Failed 'getWorkflow' server call. " + e.toString());
          context.state.isLoading = false;
          return {data: {success: false, error: e}};
        }
      },

      async setWorkflows(context) {
        try {
          let workspace = context.rootState.wsStore.workspace;
          if(!workspace)
            return;

          context.state.isLoading = true;
          var result = await Server.post("getWorkflows", { workspace }).promise;
          context.state.isLoading = false;
          if(!result.data.success)
            throw(result.data.error);

          context.state.workflows = result.data.workflows;
          return result;
        }
        catch(e) {
          console.log("Failed 'getWorkflows' server call. " + e.toString());
          context.state.isLoading = false;
          return {data:{success: false, error: e}};
        }
      },

      async releaseWorkflowLock(context, { workflow }) {
        try {
          var result = await Server.post("releaseWorkflowLock", { workflow: workflow }).promise;
          if(!result.data.success)
            throw(result.data.error);

          context.state.workflows = Util.replaceInArray(context.state.workflows, "_id", result.data.workflow);
          return result;
        }
        catch(e) {
          console.log("Failed 'releaseWorkflowLock' server call. " + e.toString());
          return {data:{success: false, error: e}};
        }
      },


      async insertWorkflow(context, { workflow }) {
        try {
          // add current user as last edited user
          workflow.lastEditedUser = context.rootState.userStore.user.username;
          let owner =  context.rootState.userStore.user.username;
          workflow.owner = owner;
          let workspace = context.rootState.wsStore.workspace;
          workflow.workspace = workspace;
          var result = await Server.post("insertWorkflow", { workflow: workflow }).promise;
          if(!result.data.success)
            throw(result.data.error);

          context.state.workflows.push(result.data.workflow);
          return result;
        }
        catch(e) {
          console.log("Failed 'insertWorkflow' server call. " + e.toString());
          return {data:{success: false, error: e}};
        }
      },

      async updateWorkflow(context, {workflow}) {
        try {
          var result = await Server.post("updateWorkflow", { workflow: workflow }).promise;
          if(!result.data.success)
            throw(result.data.error);

          context.state.workflows = Util.replaceInArray(context.state.workflows, "_id", result.data.workflow);
          return result;
        }
        catch(e) {
          console.log("Failed 'updateWorkflow' server call. " + e.toString());
          return {data:{success: false, error: e}};
        }
      },

      async deleteWorkflow(context, {workflow}) {
        try {
          var result = await Server.post("deleteWorkflow", {workflow: workflow}).promise;
          if(!result.data.success)
            throw(result.data.error);
          else if(result.data.locked)
            return result;
            
          context.state.workflows = Util.removeFromArrayByKey(context.state.workflows, "_id", workflow._id);
          return result;
        }
        catch(e) {
          console.log("Failed 'deleteWorkflow' server call. " + e.toString());
          return {data:{success: false, error: e}};
        }
      },

      async importWorkflow(context, {workflow, workspace}) {
        try {
          console.log("context ",context);
          let owner =  context.rootState.userStore.user.username;
          workflow.owner = owner;
          var result = await Server.post("importWorkflow", {workflow: workflow, workspace: workspace}).promise;
          if(!result.data.success)
            throw(result.data.error);
          
          var newWf = result.data.workflow;
          if(newWf.workspace == context.rootState.wsStore.workspace._id) {
            context.dispatch("wfStore/setWorkflows", null, {root: true});
            context.dispatch("connStore/setConnections", null, {root: true});
          }
          return result;
        }
        catch(e) {
          console.log("failed 'copyWorkflow' server call. " + e.toString());
          return {data:{success:false, error: e}};
        }
      },

      async copyWorkflow(context, {workflow, workspace}) {
        try {
          var result = await Server.post("copyWorkflow", {workflow: workflow, workspace: workspace}).promise;
          if(!result.data.success)
            throw(result.data.error);
          
          var copy = result.data.workflow;
          if(copy.workspace == context.rootState.wsStore.workspace._id) {
            context.dispatch("wfStore/setWorkflows", null, {root: true});
            context.dispatch("connStore/setConnections", null, {root: true});
          }
          return result;
        }
        catch(e) {
          console.log("failed 'copyWorkflow' server call. " + e.toString());
          return {data:{success:false, error: e}};
        }
      },

    },

  getters:
    {

    },
};



// WEBPACK FOOTER //
// ./src/store/workflow.js